import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {User} from '../../model/user.model';
import {UserInteractor} from '../../interactors/user.interactor';
import {Keys, StorageService} from '../../service/storage.service';
import {Injectable} from '@angular/core';

@Injectable()
export class BorrowerPhoneNumberVerificationResolver implements Resolve<User> {
    private readonly userInteractor: UserInteractor;
    private readonly storageService: StorageService;

    constructor(userInteractor: UserInteractor, storageService: StorageService) {
        this.userInteractor = userInteractor;
        this.storageService = storageService;
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> {
        let user;
        const loginId = await this.storageService.getObjectFromSession<string>(Keys.LOGIN_ID);
        const isPhoneNumber = /^\d{10}$/.test(loginId);
        if (isPhoneNumber) {
            user = (await this.userInteractor.getUsersByPhoneNumber(loginId))[0];
        } else {
            user = await this.userInteractor.getUserByPan(loginId);
        }
        return user;
    }

}
